import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { AppModule } from './app/app.module';

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err))
  .then(() => {
    const faviconLink = document.getElementById('app-favicon') as HTMLLinkElement;
    const themeLink = document.getElementById('app-theme') as HTMLLinkElement;
    const paletteLink = document.getElementById('app-palette') as HTMLLinkElement;

    if (faviconLink) {
      faviconLink.href = `assets/img/favicon/${environment.company}-favicon.png`;
    }

    if (themeLink) {
      let themeFile = 'th/th-light-theme.css';
      if (environment.company === 'bs') {
        themeFile = 'bs/bs-light-theme.css';
      }
      if (environment.company === 'ts') {
        themeFile = 'ts/ts-light-theme.css';
      }
      themeLink.href = `assets/styles/themes/${themeFile}`;
    }

    if (paletteLink) {
      let paletteFile = 'th/th-palette.css';
      if (environment.company === 'bs') {
        paletteFile = 'bs/bs-palette.css';
      }
      if (environment.company === 'ts') {
        paletteFile = 'ts/ts-palette.css';
      }
      paletteLink.href = `assets/styles/palettes/${paletteFile}`;
    }
  });
